import TripPlanningType, {
  type TripPlanningType as TripPlanningTypeValue,
} from '$/_const/trip/TripPlanningType.ts';

type DestinationPickState = {
  planningType?: TripPlanningTypeValue | null;
  isAutocompleteReady: boolean;
  placeId?: string | null;
  destination?: string | null;
  loadedPlaceId?: string | null;
  loadedDestination?: string | null;
};

const isUntouchedLegacyDestination = ({
  destination,
  loadedPlaceId,
  loadedDestination,
}: Pick<DestinationPickState, 'destination' | 'loadedPlaceId' | 'loadedDestination'>): boolean => {
  const loaded = loadedDestination?.trim();

  return !loadedPlaceId?.trim() && !!loaded && loaded === destination?.trim();
};

const requiresDestinationPick = ({
  planningType,
  isAutocompleteReady,
  placeId,
  destination,
  loadedPlaceId,
  loadedDestination,
}: DestinationPickState): boolean =>
  planningType === TripPlanningType.DESTINATION_IN_MIND &&
  isAutocompleteReady &&
  !placeId?.trim() &&
  !isUntouchedLegacyDestination({ destination, loadedPlaceId, loadedDestination });

export default requiresDestinationPick;
